import React from "react";

const Legend = () => (
  <div className="legend">
    <table>
      <tbody>
        <tr>
          <td
            className="perfect legendtd tooltip"
            tooltip-text={"War with 100% attacks"}
          />
          <td
            className="dayFullWar legendtd tooltip"
            tooltip-text={"War with both attacks"}
          />
          <td
            className="dayHalfWar legendtd tooltip"
            tooltip-text={"War with 1 missed attack"}
          />
          <td
            className="dayZeroWar legendtd tooltip"
            tooltip-text={"Missed war"}
          />
        </tr>
        <tr>
          <td
            className="dayOutWar legendtd2 tooltip"
            tooltip-text={"Not included in war"}
          />
          <td
            className="dayNoWar legendtd2 tooltip"
            tooltip-text={"Day without war"}
          />
          <td
            className="dayOutClan legendtd2 tooltip"
            tooltip-text={"Not a member of this clan"}
          />
          <td className="cwlLegend legendtd2 tooltip" tooltip-text={"CWL"} />
        </tr>
      </tbody>
    </table>
  </div>
);

export default Legend;
